<div class="product product-sm">
    <figure class="product-media">
        <a [routerLink]="['/product/default/'+ product.slug]">
            <molla-image [src]="product.sm_pictures && product.sm_pictures[0]?.url" alt="Product"
                [width]="product.sm_pictures[0].width" [height]="product.sm_pictures[0].height" fixedPt="100%"
                class="product-image">
            </molla-image>
            <molla-image [src]="product.sm_pictures[1]?.url" alt="Product" fixedPt="100%"
                class="product-image-hover" *ngIf="product.sm_pictures && product.sm_pictures.length >= 2"></molla-image>
        </a>
    </figure>

    <div class="product-body">
        <h3 class="product-title">
            <a [routerLink]="['/product/default/'+ product.slug]">{{ product.name }}</a><p>{{product.short_desc}}</p>
        </h3>

        <div *ngIf="loginModel && loginModel.token">
            <div class="product-price" *ngIf="!product.stock || product.stock == 0 else elseBlock">
                <span class="out-price" *ngIf="product.price != null">{{ product.price.toFixed(2) | currency:currVal }}</span>
            </div>

            <ng-template #elseBlock>
                <div class="product-price" *ngIf="minPrice == maxPrice && minPrice !== 0 else elseBlock">{{ minPrice.toFixed(2) | currency:currVal }}</div>
                <ng-template #elseBlock>
                    <div class="product-price" *ngIf=" minPrice === 0 else elseBlock">{{ product.price.toFixed(2) | currency:currVal }}</div>
                    <ng-template #elseBlock>
                        <div class="product-price" *ngIf="product.variants.length == 0 else elseBlock">
                            <span class="new-price">{{ minPrice.toFixed(2) | currency:currVal }}</span>
                            <span class="old-price">{{ maxPrice.toFixed(2) | currency:currVal }}</span>
                        </div>
                        <ng-template #elseBlock>
                            <div class="product-price">{{minPrice.toFixed(2) | currency:currVal }}&ndash;{{maxPrice.toFixed(2) | currency:currVal }}</div>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-template>
        </div>  
    </div>
</div>